import angular from 'angular';

angular.module('spa')
  .config(config);

config.$inject = ['$compileProvider'];

function config($compileProvider) {
  $compileProvider.debugInfoEnabled(false);
}



// WEBPACK FOOTER //
// ./src/config/production.config.js